import filter from "lodash/filter";
import flatMap from "lodash/flatMap";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import map from "lodash/map";
import uniq from "lodash/uniq";
import { Id, SkillsFramework } from "PFTypes";

import { ENGAGEMENT_BAR_HEIGHT, PAGE_TITLE_HEIGHT } from "./constants";

export const WORKFLOW_STATUSES_WITH_BOOKINGS = ["partially_booked", "booked", "confirmed"];

export const getAllFrameworksCustomTypeValues = (skillsFrameworks: SkillsFramework[], customTypeId: Id) =>
  uniq(
    map(
      flatMap(
        filter(
          flatMap(skillsFrameworks, "skillsFrameworkCustomTypes"),
          (customType) => customType.customTypeId === customTypeId
        ),
        "skillsFrameworkCustomValues"
      ),
      "customValueId"
    )
  );

export const isFieldBlank = (value: any) => (isArray(value) ? isEmpty(value) : isNil(value));

export const getTopOffsetStyle = (
  isEngagementBarVisible: boolean,
  isSmallScreen: boolean,
  extraOffset: string = "0px"
): number | string => {
  if (isSmallScreen) {
    return extraOffset;
  }

  if (isEngagementBarVisible) {
    // top padding + page title + gap + engagement bar + gap
    return `calc(
        var(--spacing2xl) + 
        ${PAGE_TITLE_HEIGHT}px + 
        var(--spacingLg) + 
        ${ENGAGEMENT_BAR_HEIGHT}px + 
        var(--spacingLg) +
        ${extraOffset}
      )`;
  }

  // top padding + page title + gap
  return `calc(
      var(--spacing2xl) + 
      ${PAGE_TITLE_HEIGHT}px + 
      var(--spacingLg) +
      ${extraOffset}
    )`;
};
